import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';

interface AddServiceFormProps {
  onSubmit: (domain: string) => void;
}

const AddServiceForm: React.FC<AddServiceFormProps> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [domain, setDomain] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    onSubmit(domain);
    setDomain('');
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  return (
    <div className="p-6 rounded-xl shadow bg-gradient-to-b from-[#0A1723] to-[#050C12] text-white">
      <form onSubmit={handleSubmit} className="flex flex-col md:flex-row items-center gap-3">
        <input
          type="text"
          placeholder={t('sienaguard.analyzeNow') || 'Ingresa dominio'}
          value={domain}
          onChange={e => setDomain(e.target.value)}
          required
          className="flex-1 border border-gray-300 rounded px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-[#00FF69]"
        />

        <button
          type="submit"
          className="bg-[#00FF69] text-black font-semibold px-4 py-2 rounded hover:bg-[#00e859] transition-colors flex items-center gap-2"
        >
          <FaPlus />
          {t('sienaguard.analyzeNow')}
        </button>
      </form>

      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-gradient-to-b from-[#0A1723] to-[#050C12] p-6 rounded shadow max-w-sm w-full">
            <h3 className="text-lg font-bold mb-2">
              {t('sienaguard.confirmCreateService')}
            </h3>
            <p className="mb-4">
              {t('sienaguard.domainWillBeAdded', { domain })}
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={handleConfirm}
                className="bg-[#00FF69] text-black px-4 py-2 rounded font-semibold hover:bg-[#00e859] transition-colors"
              >
                {t('sienaguard.confirm')}
              </button>
              <button
                onClick={handleCancel}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition-colors"
              >
                {t('sienaguard.cancel')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddServiceForm;
